import { render, staticRenderFns } from "./SaitenInputSeigo.vue?vue&type=template&id=06f96d12&scoped=true&"
import script from "./SaitenInputSeigo.vue?vue&type=script&lang=ts&"
export * from "./SaitenInputSeigo.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenInputSeigo.vue?vue&type=style&index=0&id=06f96d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f96d12",
  null
  
)

export default component.exports